export const environment = {
  baseUrl: 'https://backendpmt.ttcdevs.com/api/',
  socketUrl: 'https://backendpmt.ttcdevs.com',
  backendSecretKey: 'KUNU-VolkovIndia-7777',
  localStorageSecretKey: 'beautiful129*876 Rashmi',
  adminUrl: '/admin',
  acccountManagerUrl: '/account-manager',
  areaManagerUrl: '/area-manager',
  serviceEngineerUrl: '/service-engineer',
  appUrl: 'https://ttc.pmt.plus',
  clientId: 'dd418ab4-f515-40a0-83ab-ae522bfa6b36',
  allowed_countries: ['UK', 'IE', 'AT', 'BE', 'FR', 'DE', 'NL', 'PL'],
  authority:
    'https://login.microsoftonline.com/af73886c-13f3-4cb4-8af6-a568e8dcb46b',
  guestUrl: '/guest',
  googlePlaceApiKey: 'AIzaSyAUc5KPygalKXNqkFmLtyL0ZurvXTl4mGM',
};
